import { useEffect, useState } from "react";
import { fetchTripByIdApi, fetchTripByIdWithLocationApi } from "api/trips";
import { useParams } from "react-router-dom";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import { Polyline } from "./polyline";
import { useNotificationContext } from "contexts/NotificationContext";
import { GOOGLE_API_KEY } from "constants/common";
import { ITripDetailResponse } from "models/trips";
import { Spin } from "antd";
import pickupIcon from "assets/images/pickup.png";
import dropOff from "assets/images/drop-off.png";

export default function TripRouteOld() {
  const id: string = useParams().id!;
  const [data, setData] = useState<ITripDetailResponse>();
  const [currentLocation, setCurrentLocation] = useState<{
    defaultCenter: { lat: number; lng: number };
  }>({
    defaultCenter: {
      lat: 13.496494229233356,
      lng: 39.47494624044569,
    },
  });
  const { showError } = useNotificationContext();
  const [trackerCronjob, setTrackerCronjob] = useState<NodeJS.Timer>();

  useEffect(() => {
    const temp = setInterval(fetchData, 10000);
    setTrackerCronjob(temp);
    fetchData();

    return () => {
      try {
        if (trackerCronjob) clearInterval(trackerCronjob);
        if (temp) clearInterval(temp);
      } catch (error) {}
    };
  }, []); // eslint-disable-line

  const fetchData = async () => {
    const { data, error } = await fetchTripByIdWithLocationApi(id);
    if (data?.data) {
      data.data.locations.sort(
        (a, b) =>
          new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
      );
      setData(data.data);
      if (data.data.locations.length > 0)
        setCurrentLocation({
          defaultCenter: {
            lat: data.data.locations[0].latitude,
            lng: data.data.locations[0].longitude,
          },
        });
    } else showError(error!.message);
  };

  return (
    <>
      {data ? (
        <APIProvider apiKey={GOOGLE_API_KEY}>
          <Map
            style={{ width: "100vw", height: "100vh" }}
            {...currentLocation}
            defaultZoom={16}
          >
            {data.locations.length > 0 && (
              <Marker
                key={"pickup"}
                icon={{
                  url: pickupIcon,
                  size: new google.maps.Size(40, 30),
                  origin: new google.maps.Point(0, 0),
                  anchor: new google.maps.Point(20, 30),
                  scaledSize: new google.maps.Size(40, 30),
                  rotation: 1,
                }}
                optimized
                position={{
                  lat: data.locations[0].latitude,
                  lng: data.locations[0].longitude,
                }}
              />
            )}
            {data.locations.length > 1 && (
              <Marker
                key={"pickup"}
                icon={{
                  url: dropOff,
                  size: new google.maps.Size(40, 30),
                  origin: new google.maps.Point(0, 0),
                  anchor: new google.maps.Point(20, 30),
                  scaledSize: new google.maps.Size(40, 30),
                  rotation: 1,
                }}
                optimized
                position={{
                  lat: data.locations[data.locations.length - 1].latitude,
                  lng: data.locations[data.locations.length - 1].longitude,
                }}
              />
            )}
            <Polyline
              path={
                data?.locations.map((value) => ({
                  lat: value.latitude,
                  lng: value.longitude,
                })) ?? []
              }
              strokeColor="#581845"
              strokeOpacity={1.0}
              strokeWeight={4}
            />
          </Map>
        </APIProvider>
      ) : (
        <div className="w-full h-full grow flex items-center justify-center">
          <Spin size="large" />
        </div>
      )}
    </>
  );
}
